import { render, staticRenderFns } from "./introToGi.vue?vue&type=template&id=58a7fc11&"
import script from "./introToGi.vue?vue&type=script&lang=js&"
export * from "./introToGi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports